/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Fragment } from 'react';

import { Link, Typography2, breakpoints } from '@coursera/cds-core';
import { ChevronNextIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/career-academy';

type Props = { roleTitle?: string | null; backButtonUrl: string };

const styles = {
  container: () => css`
    display: flex;
    align-items: center;
    padding-bottom: var(--cds-spacing-1000);
    ${breakpoints.down('xs')} {
      padding-bottom: var(--cds-spacing-600);
    }
  `,
  nextIcon: () => css`
    margin: 0 var(--cds-spacing-200);
  `,
};

const RolePageHeroBreadcrumbs = ({ roleTitle, backButtonUrl }: Props) => {
  return (
    <div css={styles.container}>
      <Link invert href={backButtonUrl} typographyVariant="bodyPrimary">
        {_t('Back to Explore Careers')}
      </Link>
      {roleTitle && (
        <Fragment>
          <ChevronNextIcon size="small" color="invert" css={styles.nextIcon} />
          <Typography2 variant="bodyPrimary" color="invertBody" component="span">
            {roleTitle}
          </Typography2>
        </Fragment>
      )}
    </div>
  );
};

export default RolePageHeroBreadcrumbs;
